import { logError } from "src/config/logLevel/logger";
import { GrossMarginReportState } from "../interface";
import formatSalesAndReceiptData from "../utils/formatSalesAndReceiptData";
import formatMarginImpactData from "../utils/formatMarginImpactData";
import formatTrendReportData from "../utils/formatTrendReportData";
import formatCommissionCalculationData from "../utils/formatCommissionCalculationData";

export const initialState: GrossMarginReportState = {
  fromDate: "",
  toDate: "",
  initialToDate: "",
  initialFromDate: "",
  apiStatus: "pending",
  inventoryCycleApiStatus: "idle",
  apiData: {},
  salesAndReceiptData: [],
  marginImpactData: [],
  trendReportData: [],
  commissionCalculationData: [],
  caCommissionCalculationData: [],
  tableIndex: 0,
  finalizeAction: "None",
  dateRangeNotificationError: ""
};

export const handleDateRangeNotificationError = (
  state: GrossMarginReportState,
  action: { payload: { message: string } }
) => {
  state.dateRangeNotificationError = action.payload.message;
};

export const handleResetGrossMarginReport = () => initialState;

export const handleFullfillFetchGrossMarginReport = (
  state: GrossMarginReportState,
  action: { payload: { data: any; success: boolean; message: string } }
) => {
  try {
    state.apiStatus = "idle";
    const { data, success, message } = action.payload;
    if (!success) {
      state.dateRangeNotificationError = message;
    } else {
      state.apiData = data;
      state.salesAndReceiptData = formatSalesAndReceiptData(
        data?.salesAndReceipt
      );
      state.marginImpactData = formatMarginImpactData(data?.marginImpact);
      const { dateLabels, groupedData, trendReportHighlights } =
        formatTrendReportData(data?.trendReport);
      state.trendReportData = groupedData;
      state.trendReportLabels = dateLabels;
      state.trendReportHighlights = trendReportHighlights;
      const { commissionCalculationData, caCommissionCalculationData } =
        formatCommissionCalculationData(data?.commissionCalculation);
      state.commissionCalculationData = commissionCalculationData;
      state.caCommissionCalculationData = caCommissionCalculationData;
      state.finalizeAction = data?.finalizeAction;
    }
  } catch (e) {
    logError(e);
    state.apiStatus = "error";
  }
};
